/*
|--------------------------------------------------------------------------
| Component: ToggleSwitch.jsx
| Author: Sayed Ahmed
| Description: A simple, reusable toggle switch component.
|--------------------------------------------------------------------------
*/

import { useEffect, useState } from "react";

export default function ToggleSwitch({
  value = false,           // Initial value
  onChange = () => {},     // Callback on toggle
  disabled = false,        // Optional disabled state
  name = "",               // Optional input name
  id = "",                 // Optional input id
  className = "",          // Extra className
}) {
  const [checked, setChecked] = useState(value);

  // Sync local state with prop value
  useEffect(() => {
    setChecked(value);
  }, [value]);

  const handleToggle = (e) => {
    const newVal = e.target.checked;
    setChecked(newVal);
    onChange(newVal);
  };

  return (
    <div className="form-check form-switch flex justify-center items-center">
      <input
        type="checkbox"
        role="switch"
        className={`form-check-input cursor-pointer ${className}`}
        checked={checked}
        onChange={handleToggle}
        disabled={disabled}
        name={name}
        id={id || name}
      />
    </div>
  );
}
